import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Vuetify
import 'vuetify/styles' // styles de Vuetify
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'


// Icônes MDI
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'

import './styles/style.css'


// Création de l’instance Vuetify avec icônes
const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'mytheme',
    themes: {
        mytheme: {
        dark: false,
        colors: {
          blue:'#3BA7FA',     // Bleu classique
          primary: '#3BA7FA',     // Bleu classique
          secondary: 'rgb(255, 255, 255)',   // BLanc
          accent: '#82B1FF',
          background: 'rgb(255, 255, 255)',
          surface: 'rgb(255, 255, 255)',
          error: '#FF5252',
          info: '#3BA7FA',
          success: '#4CAF50',
          warning: '#FB8C00',
        },
      },
    },
  },
})

const app = createApp(App)

// Injection du router ET de Vuetify
app.use(router)
app.use(vuetify)

app.mount('#app')
